import React, { useEffect, useState } from "react";
import OtpModal from "@/components/common/modal/otp-modal/OtpModal";
import { useDisclosure } from "@mantine/hooks";
import { useForm } from "@mantine/form";
import {
  useConfirmActionSavingsAccountMutation,
  useInitActionSavingsAccountMutation,
} from "@/services/savingsAPI";
import { useLocation } from "react-router-dom";
import { useGenerateOTPMutation } from "@/services/authAPI";
import { RESULT_CODE } from "@/constants/enum";
import { notifications } from "@mantine/notifications";
import i18n from "i18n/i18n";
import { STEP } from "./types.d";
import DepositTopupContainer from "./DepositTopupContainer";
import useSavingStore from "@/stores/SavingStore/savingStore";
import { SHA256 } from "crypto-js";

const DepositTopupWrapper: React.FC = () => {
  const [step, setStep] = useState(1);
  const [isOpenedOTPModal, { open: openOTPModal, close: closeOTPModal }] =
    useDisclosure(false);
  const [, actionSavingStore] = useSavingStore();
  const { state } = useLocation();
  const [initActionSavingsAccount, { isLoading: loadingInit }] =
    useInitActionSavingsAccountMutation();
  const [generateOTP, { isLoading: loadingOtp }] = useGenerateOTPMutation();
  const [confirmActionSavingAccount] = useConfirmActionSavingsAccountMutation();
  const [otpIdCall, setOtpIdCall] = useState("");
  const form = useForm({
    initialValues: {
      otp: "",
      otpId: "",
      refId: "",
    },
    validate: {},
    validateInputOnChange: true,
  });

  const handleCloseOtp = () => {
    closeOTPModal();
  };
  const handleStepOne = async (
    beneficiaryAccountNo: string,
    actionAmount: string,
    availableBalance?: number,
  ) => {
    // immediately store the selected balance (if any) so it can be shown later
    if (availableBalance !== undefined) {
      actionSavingStore.setBeneficiaryAvailableAmount(
        availableBalance.toString(),
      );
    }

    const result = await initActionSavingsAccount({
      accountNo: state?.accountNo || "",
      action: "DEPOSIT_MANUAL_TOP_UP",
      actionAmount,
      beneficiaryAccountNo,
    });
    console.log("result", result);
    if (result.data?.body?.resultCode === RESULT_CODE.SUCCESS) {
      actionSavingStore.setBeneficiaryAccountName(
        result.data.body?.beneficiaryAccountName || "",
      );
      actionSavingStore.setBeneficiaryAccountNo(result.data.body?.beneficiaryAccountNo || "");
      // if backend returns available amount we overwrite it
      actionSavingStore.setBeneficiaryAvailableAmount(
        result.data.body?.beneficiaryAvailableAmount || "",
      );
      actionSavingStore.setBeneficiaryAccountNo(beneficiaryAccountNo);
      actionSavingStore.setInfoSavingDeposit(
        result?.data.body.savingsAccountInfo || [],
      );
      actionSavingStore.setTransInfoDeposit(
        result.data.body?.transactionInfo || [],
      );
      actionSavingStore.setAmountDisplay(actionAmount);

      form.setFieldValue("refId", result.data.body?.refId);
      setStep(STEP.STEP_2);
    } else {
      notifications.show({
        title: `${i18n.t("ERROR")}`,
        message: result.data?.body?.resultDesc || "",
        color: "red",
      });
    }

    console.log("result", result);
  };

  // const handleStepTwo = useCallback(() => {
  //   openOTPModal();
  // }, [openOTPModal]);

  const handleStepTwo = async () => {
    try {
      const otpResponse = await generateOTP({
        otpType: "SMS_OTP",
        objectId: "1234",
        objectType: "tranfer",
        phoneNumber: "0987655679",
      }).unwrap();
      console.log("otpResponse", otpResponse);
      if (otpResponse.body?.resultCode === RESULT_CODE.SUCCESS) {
        const resultOTP = otpResponse.body?.otpId;
        setOtpIdCall(resultOTP);
        console.log("otpResponse resultOTP", resultOTP);
        form.setFieldValue("otpId", resultOTP);
        openOTPModal();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleConfirmStepTwo = async () => {
    console.log("form.values.otpId", form.values.otpId);
    const res = await confirmActionSavingAccount({
      authType: "1",
      otp: SHA256(form.values.otp).toString(),
      otpId: otpIdCall,
      refId: form.values.refId,
    });
    if (res.data?.body?.resultCode === RESULT_CODE.SUCCESS) {
      actionSavingStore.setTransInfoDeposit(
        res.data.body?.transactionInfo || [],
      );
      setStep(STEP.STEP_3);
    } else {
      notifications.show({
        title: `${i18n.t("ERROR")}`,
        message: res.data?.body?.resultDesc || "",
        color: "red",
      });
    }
    handleCloseOtp();
  };

  useEffect(() => {
    return () => actionSavingStore.clearStore();
  }, []);

  useEffect(() => {
    if (isOpenedOTPModal) {
      form.setFieldValue("otp", "");
      form.setFieldValue("otpId", "");
    }
  }, [isOpenedOTPModal]);

  return (
    <>
      <DepositTopupContainer
        step={step}
        submitStepOne={handleStepOne}
        submitStepTwo={handleStepTwo}
        onBackStepOne={() => setStep(STEP.STEP_1)}
        loadingInit={loadingInit}
        loadingOtp={loadingOtp}
      />
      <OtpModal
        opened={isOpenedOTPModal}
        onClose={handleCloseOtp}
        onConfirm={handleConfirmStepTwo}
        expireTime={60}
        otp={form.values.otp}
        onChangeOtp={(value) => form.setFieldValue("otp", value)}
      />
    </>
  );
};

export default DepositTopupWrapper;
